import { useEffect, useState } from "react";
import axios from "axios";

export default function RefusedPage({ user }) {
  const [items, setItems] = useState([]);
  const { firma, pharmacyCode } = user;

  const loadData = async () => {
    const res = await axios.get(`/api/refused/${firma}/${pharmacyCode}`);
    setItems(res.data);
  };

  const handleUnblock = async (id) => {
    await axios.delete(`/api/refused/${firma}/${pharmacyCode}/${id}`);
    await loadData();
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">Odmítnuté položky</h1>
      <table className="min-w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Název</th>
            <th className="p-2 border">PDK</th>
            <th className="p-2 border">Exspirace</th>
            <th className="p-2 border">Důvod</th>
            <th className="p-2 border">Akce</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r) => (
            <tr key={r._id}>
              <td className="p-2 border">{r.poolItemId?.Název}</td>
              <td className="p-2 border">{r.poolItemId?.PDK}</td>
              <td className="p-2 border">{r.poolItemId?.Exspirace}</td>
              <td className="p-2 border">{r.reason || "-"}</td>
              <td className="p-2 border text-center">
                <button
                  onClick={() => handleUnblock(r.poolItemId._id)}
                  className="px-3 py-1 border rounded hover:bg-gray-100 text-sm"
                >
                  Zrušit blokaci
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
